import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../ExamPrepration/../header/style.css';
import { Header } from ".";
import { AdminNavbar } from ".";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';

function CreateExamPreparation() {
    const [ExamPreparationTitle, setExamPreparationTitle] = useState("");

    const [status, setStatus] = useState("");

    const navigate = useNavigate();



    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("exam_title", ExamPreparationTitle);
        formData.append("status", status);
     
        // alert(`${ExamPreparationTitle}${status}`)
        // return false

        const headers = {
            "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`
        };

        try {
            const response = await fetch(`${API_BASE_URL}/createExamPreparations/null`, {
                method: "POST",
                headers,
                body: formData,
                redirect: "follow"
            });

            const result = await response.text();

            if (response.ok) {
                console.log("Success:", result);
                navigate("/admin/ExamPreparationList");
            } else {
                console.error("Error:", result);
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Create Exam Preparation</h1>
                        </div>
                        <div className="report-body">
                            <div className="user-form">
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                <label className="form-label">Title</label>
                                    {/* Title input and Save */}
                                    <div className="mb-3 d-flex align-items-center">
                                        <input
                                            type="text"
                                            className="form-control me-2"
                                            placeholder="Enter Title"
                                            value={ExamPreparationTitle}
                                            onChange={(e) => setExamPreparationTitle(e.target.value)}
                                        />
                                   

                                    </div>

                                 

                                

                                

                                    {/* Status Dropdown */}
                                    <div className="mb-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Status</option>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>

                                    {/* Final Create Button */}
                                    <button type="submit" className="btn btn-primary">
                                        CREATE
                                    </button>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateExamPreparation;
